import { computed, ref } from 'vue'
import { useRoute } from '#app'

export const usePreview = () => {
  const route = useRoute()
  const rawPreviewToken = (
    route.query['token'] ||
    route.query['x-craft-preview']
  ) as string | undefined
  const previewToken = ref(rawPreviewToken || null)
  const previewTimestamp = ref(Date.now())

  const isPreview = computed(() => {
    return Boolean(route.query['x-craft-live-preview'] || route.query['x-craft-preview'])
  })

  // Update timestamp when preview changes
  const refreshPreview = () => {
    previewTimestamp.value = Date.now()
  }

  return {
    isPreview,
    previewToken,
    previewTimestamp,
    refreshPreview
  }
}